import { Grid } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../constants/colors';

export const StyledEditablePropertyItemContainer = styled(Grid)`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 1rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 0px 0px;
  width: 100%;
  margin: 1rem 0;

  && .label {
    font-weight: 400;
    color: #8f8f8f;
    padding-left: 0.8rem;
    font-size: 0.875rem;
    text-transform: capitalize;
  }
  && .hints {
    font-size: 0.7rem;
    padding-left: 0.4rem;
    color: #8f8f8f;
    margin: 10px;
  }
  && .value {
    font-weight: 500;
    color: ${colors.black};
    font-size: 0.875rem;
  }
  && .input-text {
    width: 100%;
    padding: 0.5rem 0.8rem;
    font-size: 0.875rem;
    border-radius: 0.5rem;
    border: 2px solid #aaa;
    background-color: #f2f2f2;
    font-weight: 400;
    margin: 0;
  }
`;
